import { AgentExecutionItem } from '@frontend/types/agentExecution';

export const getTriggerType = (execution: AgentExecutionItem) => {
  if (execution.trigger_info?.type) {
    return (
      execution.trigger_info.type.charAt(0).toUpperCase() + execution.trigger_info.type.slice(1)
    );
  }
  return execution.trigger_type || 'Manual';
};
